import React from 'react';
import { Box, Button, Container, useTheme } from '@mui/material';
import LoginUser from './LoginUser';
import Header from '../Pages/PageComponents/Header';
import Footer from '../Pages/PageComponents/Footer';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Login = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default
      }}
    >
      <Header />
      
       <LoginUser />

      <Footer />
    </Box>
  );
};

export default Login;